$(document).ready(function () {
    let modal = $("#quote_modal");
    let successModal = $("#quote_modal_success");

    // Get the button that opens the modal
    let btn = $("#btn_quote");

    let url = new URLSearchParams(location.search);
    if (url.has("contact_posted")) {
        $(successModal).addClass("show");
    }

    const validator = new window.JustValidate("#contact_form", { validateBeforeSubmitting: true });
    validator
        .addField("#fullName", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft uw volledige naam in.",
            },
            {
                rule: "minLength",
                value: 2,
                errorMessage: "Uw naam is ongeldig (minimaal 2 tekens).",
            },
        ])
        .addField("#email", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft uw e-mailadres in.",
            },
            {
                rule: "email",
                errorMessage: "Het e-mailadres is ongeldig.",
            },
        ])
        .addField("#phone", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft uw telefoonnummer in.",
            },
            // {
            //     rule: "customRegexp",
            //     value: /^(\+31|\+32|0)[6-9][0-9]{8}$/,
            //     errorMessage: "Vul alstublieft een geldig telefoonnummer in.",
            // },
            {
                rule: "minLength",
                value: 5,
                errorMessage: "Vul alstublieft een geldig telefoonnummer in.",
            },
            {
                rule: "maxLength",
                value: 20,
                errorMessage: "Vul alstublieft een geldig telefoonnummer in.",
            },
        ])
        .addField("#adress", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft uw adres in.",
            },
            {
                rule: "minLength",
                value: 2,
                errorMessage: "Uw adres is ongeldig.",
            },
        ])
        .addField("#postalCode", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft een geldige postcode in.",
            },
            {
                rule: "minLength",
                value: 4,
                errorMessage: "Uw postcode is ongeldig.",
            },
            {
                rule: "maxLength",
                value: 6,
                errorMessage: "Uw postcode is ongeldig.",
            },
        ])
        .addField("#city", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft uw stad in.",
            },
            {
                rule: "minLength",
                value: 2,
                errorMessage: "Uw stad is ongeldig.",
            },
        ])
        .addField("#country", [
            {
                rule: "required",
                errorMessage: "Vul alstublieft uw land in.",
            },
            {
                rule: "minLength",
                value: 2,
                errorMessage: "Uw land is ongeldig.",
            },
        ]);

    $("#quote_modal_success button").on("click", function (e) {
        e.preventDefault();
        $(successModal).removeClass("show");
    });

    // When the user clicks on the button, open the modal
    $(btn).on("click", function () {
        // console.log(modal);
        $(modal).addClass("show");
    });

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
        if (event.target === modal[0]) {
            console.log("close");
            $(modal).removeClass("show");
        }
    };

    // Close modal button
    $("#close-modal").on("click", function () {
        $(modal).removeClass("show");
    });

    // Setup stepper events on buttons
    $(".stepper-btn").click(function () {
        let step = $(this).data("to-step");

        // Check fields before going to next step
        if (step == 2) {
            const areaInput = $("input#surface");

            // Prevent the stepper from going to the next step if the area is less than 50m2
            if (parseInt(areaInput.val()) >= 50) {
                formStepper(step);
                $(".surface-group").removeClass("error");
                return;
            }

            // add error class if the area is less than 50m2
            $(".surface-group").addClass("error");
        } else {
            formStepper(step);
        }
    });

    // Send form data
    $("#quote_modal #contact_form button.submit").on("click", function (e) {
        e.preventDefault();

        setLoading(true);

        let hasErrors = false;

        $("#step-2 input").each((i, input) => {
            // console.log(input);
            // if empty input
            if (input.value == "") {
                // console.log("invalid");
                // add error class
                $(input).addClass("error");

                // show error message
                $("#quote_modal #contact_form .error_message").html("Voer alstublieft alle verplichte velden in.");
                $("#quote_modal #contact_form .error_message").show();

                hasErrors = true;
            } else {
                $(input).removeClass("error");
            }
        });

        if (!hasErrors) {
            // Serialize form data to an array
            let form = $("#quote_modal #contact_form").serializeArray();

            // Create body object
            let body = {
                name: form.find((i) => i.name == "contact[Naam]").value,
                email: form.find((i) => i.name == "contact[email]").value,
                telephone: form.find((i) => i.name == "contact[Telefoonnummer]").value,
                address: form.find((i) => i.name == "contact[Adres]").value,
                postcode: form.find((i) => i.name == "contact[Postcode]").value,
                city: form.find((i) => i.name == "contact[Stad]").value,
                country: form.find((i) => i.name == "contact[Land]").value,
                message: form.find((i) => i.name == "contact[body]").value,
                sku: form.find((i) => i.name == "contact[sku]").value,
                product: form.find((i) => i.name == "contact[product]").value,
                amount: form.find((i) => i.name == "contact[Hoeveelheid]").value,
                plinten: form.find((i) => i.name == "contact[Plinten]").value,
                situation: form.find((i) => i.name == "contact[Ondervloer]").value,
            };

            // Add a datalayer event to track the form submission
            const dataLayer = window.dataLayer;

            if (dataLayer) {
                dataLayer.push({
                    event: "quote_form_submitted",
                    timestamp: new Date().toISOString(),
                    formData: body,
                });
            } else console.error("dataLayer not found");

            // Revalite before submitting
            validator.revalidate().then((isValid) => {
                if (isValid) {
                    // Submit the form
                    console.log("Form is valid");
                    try {
                        // Send an ajax request to the api to store the form data to the database
                        $.ajax({
                            url: "https://api.vloerenmarkt.nl/api/v1/contact/create",
                            type: "POST",
                            "content-type": "application/json",
                            data: JSON.stringify(body),
                            succes: function (res) {
                                console.log("success", res);
                            },
                            error: function (err) {
                                console.error(err.status, err.statusText);
                            },
                        });
                    } catch (err) {
                        console.error(err);
                    }

                    // Submit the form
                    $("#quote_modal #contact_form").submit();
                }
            });
        }

        setLoading(false);
    });
});

function setLoading(bool) {
    if (bool) {
        $("#quote_modal #contact_form button.submit .atc-button--icon").css({
            opacity: "1",
            visibility: "unset",
        });
        $("#quote_modal #contact_form button.submit .atc-button--text").css("opacity", "0");
    } else {
        $("#quote_modal #contact_form button.submit .atc-button--icon").css({
            opacity: "0",
            visibility: "hidden",
        });
        $("#quote_modal #contact_form button.submit .atc-button--text").css("opacity", "1");
    }
}

function formStepper(step) {
    switch (step) {
        case 1: {
            // Show the first page, hide the second page
            $("#step-1").removeClass("hidden");
            $("#step-2").addClass("hidden");
            break;
        }

        case 2: {
            // Show the second page, hide the first page
            $("#step-2").removeClass("hidden");
            $("#step-1").addClass("hidden");
            break;
        }
    }
}
